module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "cn"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('h3', {
    staticClass: "ct"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SWITCHING BACK—SOG IS BORN")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0024-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Along with PTFs 1 and 6, these Nasty boats raided North Vietnam’s coast on 30 July and 3 August 1964. The Norwegian-led raids probably instigated the Gulf of Tonkin incident. (Photo provided by W.T. “Red” Cannon)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("T THE VERY MOMENT THAT")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLIAM")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLBY")]), _vm._v(" was beginning his secret war in Southeast Asia, half a world away a CIA-trained force of nearly 2,000 Cuban exiles landed in southern Cuba at the Bay of Pigs to overthrow Fidel Castro. Instead, they were defeated and captured by Castro’s army. President Kennedy appointed Gen. Maxwell Taylor to investigate the debacle to learn what had gone wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Taylor Commission concluded that the Cuba project had escalated beyond a size manageable by the CIA and recommended a worldwide review to learn whether other CIA enterprises had grown beyond purely intelligence operations and, if so, recommended switching them to military control. Therefore, President Kennedy ordered that Colby’s covert Vietnam programs be transferred to the military on 1 November 1963. The CIA code-named the transfer Operation Parasol, while the military dubbed it Operation Switchback.")]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CREATION OF SOG")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The November 1963 overthrow of South Vietnamese President Diem delayed Operation Parasol/Switchback; then three weeks later President Kennedy’s assassination further postponed it. Although Defense Secretary Robert McNamara approved a plan issued on 15 December 1963 for the new covert unit’s first operations, Military Assistance Command Vietnam (MACV) didn’t even get around to founding the organization until 24 January 1964—seven days before its first scheduled seaborne raid on North Vietnam.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("Commanded by an army colonel, the new unit was called the Special Operations Group ("), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo70",
      "id": "Aglo70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOG")]), _vm._v(")—then someone realized this made a mockery of security so it was renamed the Studies and Observations Group, with a cover story that SOG existed to study the combat lessons of Vietnam. In actuality, SOG would include elements of all services, including U.S. Army Green Berets, Air Force Air Commandos, and Navy SEALs. Due to its great secrecy and the sensitivity of its missions, SOG would answer directly to the Joint Chiefs of Staff in the Pentagon via a special liaison, the special assistant for counterinsurgency and special activities ("), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo62",
      "id": "Aglo62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SACSA")]), _vm._v("). In Saigon, only Gen. William Westmoreland and four non-SOG officers were even briefed on SOG. With its budget buried in U.S. Navy appropriations, SOG could receive any money it requested—South Vietnamese piastres to pay mercenaries, old French colonial silver for long-term agents in North Vietnam, U.S. greenbacks to bribe enemy officers for POW information, or even British gold sovereigns for SOG pilot survival kits.")]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHIEF SOG")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("SOG’s first commander—with the title "), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo15",
      "id": "Aglo15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chief SOG—")]), _vm._v("was Col. Clyde Russell, a World War II paratrooper who’d come into Special Forces in the 1950s. A veteran of combat parachute jumps in France and Holland with the 82nd Airborne Division’s 505th Airborne Infantry Regiment, Colonel Russell had been secretary of the Infantry School at Ft. Benning, Georgia, and then commanded the Europe-based 10th SFG and the 7th SFG at Ft. Bragg, North Carolina.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But what would SOG be? With Secretary of Defense McNamara impatiently demanding covert attacks on North Vietnam, there was little time for contemplation, so Russell’s staff shaped SOG like the old OSS into air and maritime sections, plus a psychological operations (psyops) division.")]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("COUNTERINSURGENCY SUPPORT OFFICE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("SOG could not possibly have conducted its covert operations without extraordinary logistical support and the authority to go outside military channels to meet its unique needs. The vehicle for this critical support was the Okinawa-based Counterinsurgency Support Office ("), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo16",
      "id": "Aglo16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CISO")]), _vm._v("), created at the same time as Operation Switchback. CISO would grow to keep pace with SOG’s growing needs, eventually operating its own fleet of landing ships (LST) to carry supplies to Vietnam.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The CIA, too, offered SOG logistic support via the agency’s Far East support base at Camp Chinen, Okinawa. Such exotic CIA hardware as silenced weapons and wiretap devices were transferred to CISO’s Okinawa property books until they were shipped to SOG, and then—poof!—they went off the books.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The need for sterility—concealing the origin of each item so it couldn’t be traced back to the United States—created some special challenges for CISO’s civilian deputy, Conrad “Ben” Baker. Everything issued to a SOG operative—from weapons and uniforms to rucksacks and rations—had to be untraceable. In the latter case, Baker personally developed SOG’s foil-wrapped rations, called “project indigenous rations” (PIRs), a variety of rice-based meals. Contents were described symbolically; for example, a teacup represented powdered tea, and a pepper showed that a packet contained ground red peppers. Not one word of English or any language was used.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A self-taught engineer, Baker also developed SOG’s impressive family of knives, which he manufactured clandestinely in Japan. Like the V-42 stiletto issued to the 1st Special Service Force in World War II, Baker’s SOG knives—especially the 6-inch recon knife—have become valuable artifacts of America’s secret wars, much prized by collectors.")]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SOG AND THE TONKIN GULF INCIDENT")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("From its January 1964 founding until the August 1964 air strikes that followed the Tonkin Gulf Incident, SOG was the sole U.S. instrument for military action against North Vietnam, which the Johnson administration preferred to keep as covert as Hanoi’s role in the southern fighting. The purpose of SOG’s covert raids, a McNamara memo said, was "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("to “make it clear to the leaders of the North that they would suffer serious reprisals for their continuing support of the insurgency in South Vietnam.”")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0026-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Col. Clyde Russell, the first “Chief SOG,” 1964–65, oversaw SOG’s frantic startup and covert role in the Gulf of Tonkin incident. (Photo provided by U.S. Army)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At this time, SOG was of such strategic interest that each mission plan had to weave its way among the Defense Department, State Department, and the White House for approval, with each stop liable to change, restrict, or delay SOG’s proposal. Ironically, one young foreign service officer who hand-carried the SOG target proposals from the State Department to the White House was Daniel Ellsberg, later famous as an antiwar activist who leaked the Pentagon Papers to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York Times")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0026-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("SOG’s Saigon safehouse, “House Ten,” offered comfortable, air-conditioned rooms and its own bar for visiting field operatives between missions. (Photo provided by Bill Kendall)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although SOG had inherited five CIA long-term agent teams in North Vietnam, this tiny handful of operatives was preoccupied just trying to avoid the Communist security service. The only other means for McNamara’s covert strikes was SOG’s five newly arrived high-speed gunboats, which had replaced the obsolete CIA junks. SOG’s Norwegian-built Nasty class "), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo58",
      "id": "Aglo58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patrol Type, Fast")]), _vm._v(" ("), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo43",
      "id": "Aglo43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PTF")]), _vm._v(") boats were light, heavily armed, and, at 47 knots, the fastest such boats in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To oversee the Nastys and train the boat crews and Sea Commandos, SOG created Naval Advisory Detachment, Danang, which included Detachment Echo, Seal Team One, plus a few trainers from Boat Support Unit One at Coronado, California, and a handful of U.S. Marine Force Recon advisors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("McNamara’s impatience and deniability requirements led to the strangest episode of Vietnam’s covert war. Unaccustomed to any motorized boat, the small-statured Vietnamese helmsmen were slow to master the Nasty’s tricky high-speed maneuvers. The CIA even brought in a half-dozen former Norwegian Nasty boat captains to help train the Vietnamese, but, still, they weren’t "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("ready. SOG’s SEALs volunteered to crew the Nastys, but this was unacceptable; no American SEALs ever would be allowed north of the 17th Parallel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But what about the Norwegian boat captains? "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("They weren’t Americans!")]), _vm._v(" It seemed a twisted interpretation of “deniability,” but in the rush to get McNamara’s raids underway the Norwegian skippers were pressed into service.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the night of 16 February 1964, the Norwegians attempted to land Sea Commandos to demolish a bridge on Highway One, but they came under fire before any charges had been emplaced and aborted the mission. A few days later, a swimmer demolition was attempted, and it, too, failed, with eight Sea Commandos lost. Finally, after a three-month break for more training and planning, on the night of 12 June the Nasty boats raced 100 miles north of the demilitarized zone ("), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo20",
      "id": "Aglo20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DMZ")]), _vm._v(") to bombard a storage area and barracks, leaving several buildings afire. By July SOG’s Nastys and Sea Commandos were raiding with some regularity. Then on 30 July, SOG launched its biggest night raid yet, employing all five Nastys to bombard radar sites on Hon Me and Hon Ngu Islands, so far north they were closer to Haiphong than their base at Danang.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two days later, North Vietnamese PT boats attacked the U.S. destroyer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maddox")]), _vm._v(" near Hon Me Island in what the U.S. press called the “Gulf of Tonkin Incident.” Although he made no reference to the SOG raids, of which he was well apprized, President Lyndon Johnson warned Hanoi that another high seas attack would have dire consequences, and ordered the destroyer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Turner Joy")]), _vm._v(" to reinforce the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maddox")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the night of 3 August, SOG Nastys pounded a radar at Vinhsan and threw a few shells at an enemy base on the Rhon River. The next night the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maddox")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Turner Joy")]), _vm._v(" reported themselves under attack, leading to the first U.S. retaliatory bombing and the Congressional Gulf of Tonkin Resolution. After the second incident, the Johnson administration further tightened controls on SOG, with each raid painstakingly reviewed by Deputy Defense Secretary Cyrus Vance. And no matter how important their temporary duty, the Norwegians went home, their historic role unrevealed for a quarter century.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chief SOG Russell prophetically observed, “If we were trying to convince the North Vietnamese that they could not operate from a sanctuary because the South Vietnamese were capable of hitting their beaches and their coastline, we were successful. But there is a limit to how much success you can have in that type of operation.”")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0027-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("SOG headquarters in Saigon, 137 Pasteur Street. (Photo provided by U.S. Army)")])]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LEAPING LENA")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("During that summer of 1964, a senior Special Forces officer found himself pulled into a Saigon meeting with visiting Defense Secretary McNamara. “Out of a clear blue sky I was asked how soon I could launch operations into Laos,” he recalled. “I tried to pin them down as to what kind of operations and what the mission would be since nobody had "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("enlightened me or tied it into our planning that we had already submitted.”")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0028-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Although impressive in heavy camouflage for training, South Vietnamese Special Forces did not measure up to the demands of Leaping Lena. Of 40 men parachuted into Laos, only four survived their first—and only—mission. (Photo provided by William Ewald)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("McNamara wanted the Army of the Republic of Vietnam ("), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo3",
      "id": "Aglo3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ARVN")]), _vm._v(", pronounced Arvin) to recon Laos, west of Khe Sanh, along the Ho Chi Minh Trail. The Special Forces officer warned that he could not ensure success unless American Green Berets accompanied the teams. McNamara wouldn’t allow that and insisted that the recon missions begin immediately. The resulting effort, called Project Leaping Lena, came under the newly arrived "), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo23",
      "id": "Aglo23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5th Special Forces Group")]), _vm._v(", whose "), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo56",
      "id": "Aglo56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project Delta")]), _vm._v(" was created to train and advise the Vietnamese recon unit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Five Leaping Lena teams, each with eight Vietnamese, were parachuted into Laos between 24 June and 1 July, with two teams dropped north of Tchepone astride Highway 92 near where a new road came out of North Vietnam’s Mu Ghia Pass, while three teams landed 20 miles southeast of Tchepone. It was a disaster.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "grhd"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LEAPING LENA DROP ZONES, JUNE—JULY 1964")])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0028-2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0029-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("CISO’s Okinawa office staff and secretaries ham it up in "), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo73",
      "id": "Aglo73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sterile")]), _vm._v(" uniforms and Chinese weapons. Some of SOG’s most clever psyop “gift kit” ideas originated in their fertile minds. (Photo provided by Ben Barker)")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0029-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("SOG family of knives designed by Ben Baker included (top) “banana knife” for chopping and three fighting knives. These are (left to right) Naval Commando knife with serrated upper blade, along with recon knives with 7- and 6-inch blades. All were untraceable. (Photo provided by Ben Baker)")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0029-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("U.S. Secretary of Defense Robert McNamara interceded repeatedly in SOG’s early operations. His impatience caused the premature launch of Nasty boat raids and the failure of “Leaping Lena” recon in Laos. (Photo provided by Shelby Stanton)")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0029-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("SOG’s answer to James Bond’s “Q,” Ben Baker was a self-educated engineer whose CISO office developed everything from electronic booby traps and fighting knives to the sterile “PIR” rations shown here. (Photo provided by Ben Baker)")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0030-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Short of boats, SOG’s clandestine squadron initially included Korean War-era PT810 (redesignated PTF 1). Obsolete, she was sunk in 1965 as a gunnery target. (Photo provided by W.T. “Red” Cannon)")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0030-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Flying no colors, PTF 2 (left) and PTF 3 practice high-speed maneuvers. PTF 2 and its sister craft, obsolete Korean War boats, soon were replaced by the 47-knot Norwegian Nastys, like PTF 3. (Photo provided by Batservice Holding A/S)")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0031-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Although war critics later alleged that there was no Tonkin Gulf clash, the first incident documentably occurred. Shown here, a Communist PT boat runs past USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maddox")]), _vm._v(" as a shell bursts to her rear. (Photo provided by U.S. Navy)")])]), _vm._v(" "), _c('div', {
    staticClass: "bg2"
  }, [_c('p', {
    staticClass: "bghd"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SOG’S AMAZING NASTY BOATS")])]), _vm._v(" "), _c('p', {
    staticClass: "s_noindent"
  }, [_vm._v("William Colby had identified the need for high-speed foreign gunboats for covert operations in Southeast Asia when he headed these operations. Due to its great speed and deniability, the Norwegian Tjeld class PT boat was selected, with the contractor, Batservice A/S, delivering the first of 14 boats to the United States in December 1962. SOG received five boats in early 1964.")]), _vm._v(" "), _c('p', {
    staticClass: "s_noindent"
  }, [_vm._v("The fastest craft of their type in the world, the 88-footers were called Nasty class and understandably designated Patrol Type, Fast (PTFs). Propelled by two powerful 6,200-horsepower, 36-cylinder, British Deltic Napier turbo-diesel engines, the plywood-hulled Nastys skimmed the water at 47 knots, while rattling away with one 40mm and two 20mm cannons plus a .50-caliber machine gun. Some boats even added an 81mm mortar. The Norwegian torpedo tubes had been removed to lighten the Nastys and allow space for its considerable other armaments. Given this combination of speed and firepower, a Nasty could outrun North Vietnam’s sluggish, Chinese-supplied Swatows or outshoot Hanoi’s 45-knot, Soviet P-4 PT boats.")]), _vm._v(" "), _c('p', {
    staticClass: "s_noindent"
  }, [_vm._v("With a cruising range of 860 nautical miles, the Danang-based boats could raid the entire coast of North Vietnam, all the way up to southern China. To replace lost Nastys and expand SOG’s flotilla, six more were built from 1967 to 1968, on license by John Trumpy & Sons of Annapolis, Maryland, and finally an additional four by the Stewart Seacraft Division of Teledyne in Berwick, Louisiana.")]), _vm._v(" "), _c('p', {
    staticClass: "s_noindent"
  }, [_vm._v("Despite efforts to conceal the location and purpose of SOG’s top-secret raiding boats, the 1969–1970 edition of Jane’s Fighting Ships listed the Nastys and observed, “These craft are used on clandestine missions in Southeast Asia.”")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0031-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Between raids on North Vietnam’s coast, a Norwegian-built Nasty patrol boat is docked at SOG’s Danang base.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "grhd"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SOG COASTAL RAIDS")])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0032-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0032-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("NAD’s unofficial emblem featured a mask behind whose eyes lurked the U.S. Navy and Marine Corps, symbolizing that they were behind the Vietnamese raids on North Vietnam.")])]), _vm._v(" "), _c('div', {
    staticClass: "bg2"
  }, [_c('p', {
    staticClass: "bghd"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GET OUT OF JAIL FREE CARD")])]), _vm._v(" "), _c('p', {
    staticClass: "s_noindent"
  }, [_vm._v("To prevent inquisitive military police (MPs) or curious officers from disrupting clandestine activities, SOG’s American operatives were issued the Vietnam War’s most unique credential, nicknamed the “Get Out of Jail Free Card.” Officially MACV Form 4569, the SOG card authorized its bearer civilian clothes, entry into off-limits areas, concealed weapons, no curfews, and the authority to commandeer soldiers, weapons, and vehicles without need for explanation. Early on, the card was carried by all SOG troopers, but after a few inebriated Green Berets commandeered MP jeeps for barhopping in Saigon, the good deal came to a halt. After that the card was issued to the select few who absolutely needed it.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0032-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Get Out of Jail Free” card.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Presidential adviser McGeorge Bundy was told, “All of the teams were located by the enemy, and only four survivors returned.” The survivors reported encountering company-size elements of the North Vietnamese Army ("), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo48",
      "id": "Aglo48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NVA")]), _vm._v(") and finding the bridges along Route 9 heavily defended by communist Pathet Lao. While fleeing eastward, they’d crossed a network of roads and trails invisible from the air, some carrying truck convoys.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leaping Lena was finished. Soon afterward, the 5th Special Forces converted Project Delta into the first U.S. long-range recon unit in Vietnam. But what was happening in southern Laos? Now it would be up to SOG to find out.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84851ddc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Chapter2.vue
// module id = 90
// module chunks = 0